module.exports = function () {
  /**
  * @file core/versionMap.js
  * 维护端能力的v版本信息。存在的必要性：端能力版本和端的版本不是一一对应的，Android和iOS可能分别在不同的端版本上升级了端能力，但server端下发功能的时候需要针对特定端能力版本下发。规则：key为scheme的path除v之外的部分，value是映射到的v的值
  * @author gaojiexuan@baidu.com
  */
  return {};
}();